import { render, staticRenderFns } from "./UserGridInstructor.vue?vue&type=template&id=5989be67&"
import script from "./UserGridInstructor.vue?vue&type=script&lang=js&"
export * from "./UserGridInstructor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports